<style src="./EmployeeMap.scss" lang="scss"></style>
<template>
  <div>
    <form @submit.prevent="sendCampaign" class="formcontainer">
      <div class="inputcontainer">
        <div class="inputcontent">
          <label>Digite o inicio do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeInitial"
          />
        </div>
        <div class="inputcontent">
          <label>Digite o fim do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeFinal"
          />
        </div>
        <div class="inputcontent">
          <label>Selecione o monitor</label>
          <select class="form-select" v-model="form.selectedEmployee">
            <option
              v-for="(employee, index) in employees"
              :key="index"
              :value="employee.userToken"
              >{{ employee.fullName }}</option
            >
          </select>
        </div>
      </div>
      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-lg btn-primary "
          @click="loadEmployeeLocation"
        >
          <i class="fa fa-search"></i>
          Buscar
        </button>
      </div>
    </form>
    <GmapMap
      class="mapcontainer"
      :center="center"
      :zoom="16"
      :options="mapOptions"
    >
      <gmap-heatmap-layer
        :data="heatMapData"
        :options="{
          // maxIntensity: 80,
          dissipating: true,
          radius: 50,
          opacity: 0.8,
        }"
      />
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "gmap-vue";
import { format } from "date-fns";

export default {
  name: "ParkingMap",
  data: () => ({
    center: { lat: -22.4732992, lng: -43.8566519 },
    employeesLocations: [],
    employees: [],
    mapStyles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
    form: {
      dateTimeInitial: "",
      dateTimeFinal: "",
      selectedEmployee: "",
    },
    initialDateLimit: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
  }),
  computed: {
    google: gmapApi,
    heatMapData() {
      if (this.google) {
        const markersHeat = this.employeesLocations.map((employee) => {
          return {
            location: new this.google.maps.LatLng({
              lat: employee.coordinates[0],
              lng: employee.coordinates[1],
            }),
            weight: 10,
          };
        });
        return markersHeat;
      }
      return [];
    },
    mapOptions() {
      return {
        styles: this.mapStyles,
      };
    },
  },
  mounted() {
    this.loadEmployees();
  },
  methods: {
    async loadEmployeeLocation() {
      try {
        const employeeLocations = await this.$store.dispatch(
          "EMPLOYEE/ListEmployeeLocation",
          {
            dateTimeInitial: this.form.dateTimeInitial,
            dateTimeFinal: this.form.dateTimeFinal,
            employeeToken: this.form.selectedEmployee,
          }
        );

        employeeLocations.location
          ? (this.employeesLocations = employeeLocations.location)
          : (this.employeesLocations = employeeLocations);
      } catch (error) {
        this.$toasted.error(
          "Não foi possível listar a localização dos monitores"
        );
      }
    },
    async loadEmployees() {
      try {
        const employeesList = await this.$store.dispatch(
          "EMPLOYEE/GetEmployeeList",
          {
            accountEnabled: true,
          }
        );
        this.employees = employeesList;
        this.form.selectedEmployee = employeesList[0].userToken;
      } catch (error) {
        this.$toasted.error("Não foi possível listar os monitores");
      }
    },
  },
};
</script>
